/**
 * Mirror frontend dei valori TIPO di backend/services/hrNormativeStandards.js
 * (OptionSet phc_tipo su phc_hrstdanagraficas). Il frontend non può importare
 * moduli backend: questi valori vanno tenuti allineati manualmente.
 */
export const TIPO = {
  REGIONE: 100000000,
  PROFILO: 100000001,
  AREA: 100000002,
  MANSIONE: 100000003,
  TURNO: 100000004,
  TIPOLOGIA_MANSIONE: 100000005,
};

export const TIPOLOGIA_STANDARD = [
  { value: "per_mansione", label: "Per mansione (minutaggio diretto)" },
  { value: "per_area", label: "Per area funzionale" },
  { value: "aggregato", label: "Aggregato (pool unico)" },
];

export const UNITA_MISURA = [
  { value: "MIN_DIE", label: "Minuti/die per ospite" },
  { value: "MIN_SETT", label: "Minuti/sett per ospite" },
  { value: "ORE_SETT", label: "Ore/sett" },
];

export const TIPO_CALCOLO = [
  { value: "MINUTAGGIO", label: "Minutaggio" },
  { value: "RAPPORTO", label: "Rapporto (es. 1 ogni N ospiti)" },
  {
    value: "FLAT_SETT",
    label: "Flat per struttura/nucleo (ore/sett, non scala con gli ospiti)",
  },
];
